import React, { useState } from 'react';
import {
  Badge,
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Spinner,
  Table,
} from 'reactstrap';
import moment from 'moment';

const pick = (row, keys, fallback = '') => {
  for (let i = 0; i < keys.length; i += 1) {
    const value = row?.[keys[i]];
    if (value !== undefined && value !== null && value !== '') return value;
  }
  return fallback;
};

const formatDate = (value) =>
  value ? moment(new Date(value)).format('DD MMM YY') : '-';

const formatTime = (value) => (value ? moment(new Date(value)).format('HH:mm') : '');

// is_refund: 1 = COD amount received (approved), 2 = rejected
export const getDecision = (row) => {
  const flag = String(pick(row, ['is_refund', 'is_approved', 'approved'], ''));
  if (flag === '1' || flag === 'true') return 'approved';
  if (flag === '2') return 'rejected';
  return '';
};

const CodReturnOrdersList = ({
  rows,
  isLoading,
  error,
  startIndex,
  onDecision,
  pendingId,
}) => {
  const columnCount = 8;
  const [confirm, setConfirm] = useState(null);

  const handleConfirm = async () => {
    const request = confirm;
    setConfirm(null);
    if (request) await onDecision(request.row, request.action);
  };

  const confirmRow = confirm?.row || {};
  const isReject = confirm?.action === 'reject';

  return (
    <>
      <div className="table-responsive">
        <Table className="OrderListTable table mb-0">
          <thead>
            <tr>
              <th>SI.No</th>
              <th nowrap="nowrap">Date</th>
              <th nowrap="nowrap">Return Reference</th>
              <th nowrap="nowrap">Order No</th>
              <th nowrap="nowrap">LS Reference</th>
              <th>Reason</th>
              <th nowrap="nowrap">Payment Mode</th>
              <th nowrap="nowrap">Action</th>
            </tr>
          </thead>
          <tbody>
            {isLoading ? (
              <tr>
                <td colSpan={columnCount} className="text-center py-4">
                  <Spinner className="ms-2 sploader" color="primary" />
                </td>
              </tr>
            ) : error ? (
              <tr>
                <td colSpan={columnCount} className="text-center py-4 text-danger">
                  {error}
                </td>
              </tr>
            ) : rows?.length > 0 ? (
              rows.map((row, index) => {
                const rowId = pick(row, ['queue_id', 'id'], '');
                const createdAt = pick(row, ['created_at', 'createdAt'], '');
                const decision = getDecision(row);
                const busy = pendingId === rowId;
                return (
                  <tr key={rowId || index}>
                    <th scope="row">{startIndex + index + 1}</th>
                    <td>
                      <span className="fs-12">{formatDate(createdAt)}</span>
                      <p className="fs-12 mb-0">{formatTime(createdAt)}</p>
                    </td>
                    <td className="ReturnInfo1">
                      <span className="fs-12">
                        {pick(row, ['reference_number', 'reference_no'], '-')}
                      </span>
                      <p className="fs-12 mb-0 text-muted">
                        {pick(row, ['queue_type'], '')}
                      </p>
                    </td>
                    <td>
                      <span className="fs-12">
                        {pick(row, ['order_id', 'web_order_no', 'order_no'], '-')}
                      </span>
                    </td>
                    <td>
                      <span className="fs-12">{pick(row, ['ls_reference'], '-')}</span>
                    </td>
                    <td>
                      <span className="fs-12">{pick(row, ['reason'], '-')}</span>
                    </td>
                    <td>
                      <span className="fs-12">
                        {pick(row, ['payment_mode', 'payment_method'], '-')}
                      </span>
                    </td>
                    <td>
                      <div className="action-flex-container d-flex gap-2">
                        {decision === 'approved' && (
                          <Badge color="success" className="badge badge-pill">
                            Cash Received
                          </Badge>
                        )}
                        {decision === 'rejected' && (
                          <Badge color="danger" className="badge badge-pill">
                            Cash Not Received
                          </Badge>
                        )}
                        {!decision && (
                          <>
                            <Button
                              color="success"
                              size="sm"
                              disabled={busy}
                              onClick={() => setConfirm({ row, action: 'approve' })}
                            >
                              {busy ? (
                                <span
                                  className="spinner-border spinner-border-sm"
                                  role="status"
                                  aria-hidden="true"
                                ></span>
                              ) : (
                                'Cash Received'
                              )}
                            </Button>
                            <Button
                              color="danger"
                              size="sm"
                              disabled={busy}
                              onClick={() => setConfirm({ row, action: 'reject' })}
                            >
                              Cash Not Received
                            </Button>
                          </>
                        )}
                      </div>
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan={columnCount} className="text-center py-4">
                  No Records found
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>

      <Modal isOpen={Boolean(confirm)} toggle={() => setConfirm(null)}>
        <ModalHeader toggle={() => setConfirm(null)}>
          {isReject ? 'Cash Not Received' : 'Cash Received'}
        </ModalHeader>
        <ModalBody>
          {isReject
            ? 'Confirm the COD amount was NOT received for return '
            : 'Are you sure you got the COD amount for return '}
          <strong>{pick(confirmRow, ['reference_number'], '')}</strong> on order{' '}
          <strong>{pick(confirmRow, ['order_id'], '')}</strong>?
        </ModalBody>
        <ModalFooter>
          <Button color="light" onClick={() => setConfirm(null)}>
            Cancel
          </Button>
          <Button color={isReject ? 'danger' : 'success'} onClick={handleConfirm}>
            {isReject ? 'Cash Not Received' : 'Cash Received'}
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default CodReturnOrdersList;
